module.exports = __webpack_public_path__ + "img/poster.2754b38d.png";